<template>
  <v-app id="main">
    <router-view class="ma-0 pa-0"></router-view>
  </v-app>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

export default {
  name: "ApliComp",
  components: {},
  data: () => ({}),

  computed: {
    company() {
      return "Portal Siglobpo";
    },

    empresaUsuario() {
      if (this.user.tipo_usuario == 1) {
        return this.user.empresa;
      }
      if (this.user.tipo_usuario == 4) {
        return "Portal Siglobpo";
      }

      return "na";
    },

    ...mapGetters("access", ["getIsLoggedIn", "store", "users", "admin"]),

    ...mapState("access", ["modules", "idActionsRol"]),

    ...mapState("master", [
      "companies",
      "user",
      "token",
      "tenantId",
      "drawer",
      "menu",
      "titleToolbar",
    ]),
  },
  methods: {
    ...mapActions("master", ["requestApi", "alertNotification", "setDrawer"]),
    ...mapActions("access", ["errorRequest", "getModules"]),
    ...mapMutations("master", ["setUrl", "setMenu", "setDrawer"]),
    ...mapMutations("access", [
      "setLogedIn",
      "setActionsRol",
      "setAvailableModules",
    ]),

    logout() {
      this.setUrl("api/logout");
      this.requestApi({
        method: "post",
        data: {
          token: this.token,
          user_name: this.user.user_login_id,
          //dataBase: this.tenantId,
          system: "portal_siglobpo",
          comment: "ha cerrado sesión ",
        },
      })
        .then((res) => {
          localStorage.removeItem("token");
          localStorage.setItem("user", "");
          this.setMenu([]);
          this.setLogedIn(false);
          this.setActionsRol();
          //console.log(res);
          this.alertNotification({
            param: {
              html: "Adios " + this.user.name,
              toast: true,
              timer: 1000,
            },
          });
          if (!this.loggedIn) {
            //this.$router.push("#/login");
            //window.location.replace("/");
            this.$router.go(0);
          }
        })
        .catch((err) => {
          //console.log(err);
          let response = err.response;
          this.errorRequest({
            data: {
              datos: response.data.errors,
              status: response.status,
            },
          });
        });
    },
  },

  mounted() {
    //this.setMenu(JSON.parse(localStorage.getItem("menu")));
    document.title = "Portal de Talento Humano";
    // if (this.getIsLoggedIn == false) {
    //   this.f1();
    // } else {
    //   let n = document.getElementById("main");
    //   n.style.backgroundImage = "#ffffff";
    // }
  },
};
</script>
<style>
/*#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
*/
/*nav {
  background-color: aqua;
  color: antiquewhite;
}*/

.v-theme--dark.v-navigation-drawer {
  background-color: #363636;
}
/*nav a {
  font-weight: bold;
  color: #2c3e50;
}*/

/*nav a.router-link-exact-active {
  color: #42b983;
}*/

.v-list-group {
  width: 100%;
}

.v-list-group__header {
  padding: 0 !important;
}

.menu-drop-down {
  font-size: 12px;
  font-weight: 500;
}

.v-list-group__header__append-icon {
  position: absolute;
  right: 0;
}
</style>
